<template>
  <v-dialog
    v-model="dialog"
    max-width="750"
    persistent
    scrollable
    :fullscreen="isMobile()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="info"
        :block="isMobile()"
        rounded
        depressed
        height="30"
        :disabled="novopedido.produtos.length > 0 || lista_itens.length > 0"
      >
        <v-icon size="22" left>mdi-account-search-outline</v-icon> Selecionar
        cliente</v-btn
      >
    </template>
    <v-card>
      <v-card-title
        :class="
          'font-weight-bold ' +
          (isMobile() ? 'green lighten-5 primary--text' : '')
        "
      >
        <v-row dense>
          <v-col align-self="center">Selecionar cliente</v-col>
          <v-col v-if="isMobile()" align-self="start" cols="auto"
            ><v-btn dark icon color="primary" large @click="dialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            ></v-col
          >
        </v-row>
      </v-card-title>
      <v-card-text class="mt-3">
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="mb-0">
              <v-text-field                
                label="Pesquisar cliente"
                placeholder="Pesquise por nome ou matrícula"
                v-model="pesquisa"
                autofocus
                :rules="rulesPesquisa()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0">
              <v-btn
                color="info"
                rounded
                block
                @click="buscarClientes()"
                :loading="loadingClientes"
                height="32"
                depressed
                >Buscar clientes</v-btn
              >
            </v-col>

            <v-col cols="12">
              <template v-if="isMobile()">
                <v-list-item
                  v-for="(cli, i) in clientes"
                  :key="i"
                  class="grey lighten-4 mt-1"
                >
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold body-1">{{
                      cli.nome
                    }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <p class="mb-1">{{ cli.matricula }}</p>
                      <p class="mb-0">{{ cli.cidade }}/{{ cli.uf }}</p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      text
                      block
                      rounded
                      color="info"
                      small
                      @click="selecionarCliente(cli)"
                      >Selecionar</v-btn
                    ></v-list-item-action
                  >
                </v-list-item>
              </template>
              <v-data-table
                v-else
                :items="clientes"
                :headers="headers"
                no-data-text="Nenhum cliente encontrado"
                :hide-default-footer="clientes.length == 0"
                :disable-sort="isMobile()"
                :items-per-page="5"
              >
                <template v-slot:[`item.cidade`]="{ item }">
                  {{ item.cidade }}/{{ item.uf }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    height="32"
                    text
                    block
                    rounded
                    color="info"
                    @click="selecionarCliente(item)"
                    >Selecionar</v-btn
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer v-if="!isMobile()"></v-spacer>
        <v-btn
          rounded
          @click="dialog = false"
          :text="!isMobile()"
          color="secondary"
          :block="isMobile()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.pesquisa = "";
      }
    },
  },
  data: () => ({
    dialog: false,
    pesquisa: "",
    loadingClientes: false,
    headers: [
      { text: "Matrícula", value: "matricula" },
      { text: "Cliente", value: "nome" },
      { text: "Cidade", value: "cidade" },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("clientes", ["clientes"]),
    ...mapState("pedidos", ["novopedido"]),
    ...mapState("insumos",["lista_itens"])
  },
  methods: {
    ...mapMutations("clientes", ["setClientes"]),
    ...mapActions("clientes", ["getClientes"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async buscarClientes() {
      if (this.$refs.form.validate()) {
        this.loadingClientes = true;
        this.setClientes(await this.getClientes({ pesquisa: this.pesquisa }));
        this.loadingClientes = false;
      }
    },
    selecionarCliente(cli) {
      this.novopedido.cliente = cli;
      this.dialog = false;
    },
    rulesPesquisa() {
      return navigator.onLine ? [] : [(v) => !!v || "Nenhum caracter informado para a pesquisa"];
    },
  },
};
</script>

<style>
</style>